import '../../App.css'
import wordMark from '../../Assets/Images/Logo/WordMark.png'
import metaLogo from '../../Assets/Images/Logo/Meta 1 - No Gear.png'
import saitSaLogo from '../../Assets/Images/Logo/Saitsa/Saitsa Clubs Logo - Primary - light.png'

import { useState } from 'react';
import { motion } from 'framer-motion'
import Card from '../Card'
import About from '../About'
import AnimatedWave from '../AnimatedWave'

function HomePage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    if (!name || !email || !message) {
      setError('All fields are required.');
      return;
    }

    window.location.href = `mailto:meta.saitclub@outlook.com?subject=Contact from ${name}&body=${message}%0A%0AFrom: ${email}`;
    setSuccess('Message ready to send via your email client!');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <>
      <div className="Page1">
        <div style={{ width: '90%', position: 'absolute', top: 0, zIndex: 3, padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <img style={{ height: '20px', width: 'auto' }} src={metaLogo} alt="MetaLogo" />
        </div>
        <AnimatedWave />
        <div className="intro">
          <Card animation="fade-right">
            <span className="highlight">
              Connecting SAIT mechanical engineering students with the skills, network, and opportunities that launch careers.
            </span>
            <br />

      <div className="join-btn-container">
        <a
          style={{ textDecoration: 'none' }}
         href="https://forms.cloud.microsoft/r/EX3QJQMuPH"
          target="_blank"
          rel="noopener noreferrer"
          className="join-meta-btn"
          >
          Apply
        </a>
      </div>
            <br />

          </Card>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <img style={{ marginLeft: '-25px' }} src={wordMark} width="250px" alt="Meta" />
              <img src={saitSaLogo} height="30px" alt="SAITSA Clubs Logo" />
            </div>
          </motion.div>
        </div>
      </div>

      <About />
      <div className="section-divider-angled"></div>

      {/* <div className="Page3">
        <Partners />
        <Events />
      </div>

      <div className="Page3" style={{ paddingTop: 20, paddingBottom: 20 }} id="shop">
        <Merch />
      </div> */}

      <div className="Page4" id="contact">
        <section className="contact-section">
          <div className="contact-wrapper">
            <div className="contact-text">
              <h2 className="contact-title">Contact Us</h2>
              <p className="contact-description">
                Got a question, idea, or opportunity? We’d love to hear from you!
                Whether you're a student, a guest, or a company interested in
                partnerships or sponsorships, reach out using the form below.
              </p>
              <p className="contact-description">
                <strong>META</strong> offers valuable opportunities for collaboration with industry partners.
                <br />
              </p>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              {error && <p className="error">{error}</p>}
              {success && <p className="success">{success}</p>}

              <label>Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Jane Doe" />

              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" />

              <label>Message</label>
              <textarea name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Let us know how we can help" />

              <button type="submit">Send Message</button>
            </form>
          </div>
        </section>
        <div>
          <h6 style={{ textAlign: 'center', padding: '10px' }}>
            Mechanical Engineering Technology Association | 2025–2026 | Southern Alberta Institute of Technology
          </h6>
        </div>
      </div>


    </>
  );
}

export default HomePage;
